import { gql } from '@apollo/client'

const DELETE_SOP_MUTATION = gql`
  mutation deleteSop($id: ID!) {
    deleteSop(id: $id)
  }
`

export default DELETE_SOP_MUTATION
